import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import adminApi, { setToken, isLoggedIn } from '../../api/adminClient';
import './Admin.css';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/admin/company';

  // 이미 로그인된 상태면 바로 대시보드로
  React.useEffect(() => {
    if (isLoggedIn()) navigate('/admin/company', { replace: true });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError(null);
    try {
      const data = await adminApi.login(password);
      setToken(data.token);
      navigate(returnTo, { replace: true });
    } catch (err) {
      setError(err.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <form className="admin-login__card" onSubmit={handleSubmit}>
        <div className="admin-login__logo">
          <span className="admin-login__logo-icon">H</span>
          <div>
            <div className="admin-login__logo-kr">주식회사 허브</div>
            <div className="admin-login__logo-en">ADMIN CONSOLE</div>
          </div>
        </div>
        <h1>관리자 로그인</h1>
        <p className="admin-login__sub">채용공고 및 접수 내역을 관리합니다.</p>

        {error && <div className="form-error">{error}</div>}

        <div className="form-group">
          <label>관리자 비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
            autoFocus
          />
        </div>

        <button type="submit" className="btn btn-primary admin-login__submit" disabled={loading}>
          {loading ? '확인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}
